import { action, observable } from 'mobx';
import { WebGivingPage } from '../index';
import { ValidationState } from '../../validation/view-model-validator';
import {
	PaymentLabel,
	FrequencyCode,
	RecurringSuggestionQueryResult,
	AppContentCardModel,
	ThankYouAnimationType,
	WebGivingPaymentResultStatus,
} from '../../webgiving-generated';
import { SplitLineItem } from '../../utils/webgiving-utils';
import { WebGivingPageViewModelBase } from '../page-view-model-base';

export interface SplitLineItemResult extends SplitLineItem {
	FundName: string;
	paymentStatus: WebGivingPaymentResultStatus;
}

export interface IPagePaymentSuccessData {
	isRecurring: boolean;
	giftAmount: number;
	fundName: string;
	emailAddress: string;
	paymentLabel: PaymentLabel;
	receiptSent: boolean;
	stillProcessing: boolean;
	wasDelayed: boolean;
	merchantCurrency: string;
	merchantName: string;
	successThankYouMessage: string;
	merchantAppName: string;
	getAppUrl: string;
	hasWelcomeSmsBeenSent: boolean;
	hasCustomApp: boolean;
	recurringStartDate: Date | undefined;
	recurringFrequency: FrequencyCode | undefined;
	hideAppCallToAction: boolean;
	isBranded: boolean;
	recurringInfo: RecurringSuggestionQueryResult | null;
	appContentCard: AppContentCardModel | null;
	isOneTimeFutureGift: boolean;
	oneTimeGiftDate: Date | null;
	fastModeAvailable: boolean;
	fastModeDailyLimit?: number | null;
	fastModeCurrentlyEnabled: boolean;
	thankYouText: string;
	thankYouTextHtml: string
	returnButtonText: string;
	returnButtonUrl: string;
	thankYouAnimation: ThankYouAnimationType;
	splitLineItemResults: SplitLineItemResult[];
}

export class PagePaymentSuccessViewModel extends WebGivingPageViewModelBase {
	readonly type: WebGivingPage.PaymentSuccess = WebGivingPage.PaymentSuccess;

	@observable
	validationState?: ValidationState;

	@observable
	isFastModeOn: boolean;

	@observable
	isFastModeLoading: boolean;

	readonly thankYouText: string;
	readonly returnButtonText: string;
	readonly returnButtonUrl: string;
	readonly thankYouTextHtml: string;

	constructor(public data: IPagePaymentSuccessData) {
		super();
		const { fastModeCurrentlyEnabled, thankYouText, returnButtonText, returnButtonUrl, thankYouTextHtml } = data;
		this.isFastModeOn = fastModeCurrentlyEnabled;
		this.thankYouText = thankYouText || '';
		this.thankYouTextHtml = thankYouTextHtml || '';
		this.returnButtonText = returnButtonText || '';
		this.returnButtonUrl = returnButtonUrl || '';
	}

	validate(): ValidationState {
		return { isValid: true };
	}

	@action
	setFastModeLoading (loading: boolean) {
		this.isFastModeLoading = loading;
	}

	@action
	setFastMode (mode: boolean) {
		this.isFastModeLoading = false;
		this.isFastModeOn = mode;
	}
}
